import $ from 'jquery';
class Nav {

	constructor(element) {
		$(document).ready(() => this.load());
	}

	load() {
		this.navList = $('.js-nav-list');
		this.toggleBtn = $('[data-toggle="nav"]');
		this.languages = $('.navigation__language-toggle');
		this.languageToggle = $('.language-toggler');
		this.overlay = $('.twz-overlay');

		this.toggleBtn.on('click',(e) => this.toggleNav());

		this.languageToggle.on('click',(e) => this.toggleLang());

		this.overlay.on('click', (e) => function(e){
			if(this.navList.hasClass('is-expanded')) {
				this.toggleNav(e);
			}
		})

		$('.navigation__lists_mobile li.menu-item-has-children').on('click',function(e) {
			if ( $(e.target).is('li') ) {
				$(this).toggleClass('active');
			}
		});

 
		document.body.style.setProperty('--nav-height', `${document.querySelector('.navigation') ? document.querySelector('.navigation').offsetHeight : 0}px`)
	}

	toggleNav(e) {
		$('body').toggleClass('no-scroll');
		$('body').toggleClass('menu-expanded');
		this.navList.toggleClass('is-expanded');
		this.toggleBtn.find('.hamburger').toggleClass('is-exciting');
	}


	toggleLang() {
		this.languages.toggleClass('active');
	}

}

new Nav